// @file
// Fetch parent menu item from menu.

const matchesUrl = (url, item) => {
  return item.relative === url || `/${item.uri}` === url;
};

const hasUrlAsChild = (url, item) => {
  return (item.below || []).filter(below => matchesUrl(url, below)).length;
};

const reduceTree = (url, tree = [], matchingStrategy = "child") =>
  tree.reduce((agg, item) => {
    if (matchingStrategy === "child" && hasUrlAsChild(url, item)) {
      agg.push(item);
    } else if (matchingStrategy === "self" && matchesUrl(url, item)) {
      agg.push(item);
    } else {
      agg = agg.concat(reduceTree(url, item.below || [], matchingStrategy));
    }
    return agg;
  }, []);

export const fetchParentMenuItem = (location, menuTree) => {
  const reduced = reduceTree(location.pathname, menuTree, "child");
  return reduced.length > 0 ? reduced[0] : null;
};

export const fetchOwnMenuItem = (location, menuTree) => {
  const reduced = reduceTree(location.pathname, menuTree, "self");
  return reduced.length > 0 ? reduced[0] : null;
};
